import { driver } from "driver.js";
import "driver.js/dist/driver.css";

const icon = (name) => `<i class="lucide-${name} me-2"></i>`;

const commonConfig = {
    showProgress: true,
    animate: true,
    overlayColor: 'rgba(0, 0, 0, 0.92)',
    stagePadding: 12,
    stageRadius: 16,
    popoverClass: 'orion-tour-popover',
    nextBtnText: 'Siguiente →',
    prevBtnText: '← Anterior',
    doneBtnText: '¡Entendido!',
    closeBtnText: '✕',
};

// 1. MIS CURSOS DOCENTE
export const startDocenteMisCursosTour = () => {
    const driverObj = driver({
        ...commonConfig,
        steps: [
            {
                element: '.view-mode-switch',
                popover: {
                    title: '<i class="fas fa-desktop text-primary me-2"></i> Modo de Vista',
                    description: 'Puedes elegir entre ver tus cursos en una <b>Grilla</b> tradicional o un <b>Carrusel</b> interactivo.',
                    side: "bottom",
                    align: 'start'
                }
            },
            {
                element: '.premium-search-container',
                popover: {
                    title: '<i class="fas fa-search text-primary me-2"></i> Buscador Rápido',
                    description: '¿Tienes muchos cursos? Filtra por nombre, grado o sección al instante.',
                    side: "bottom",
                    align: 'center'
                }
            },
            {
                element: '.joyride-course-card',
                popover: {
                    title: '<i class="fas fa-book text-primary me-2"></i> Tus Cursos',
                    description: 'Aquí verás los cursos que tienes asignados en el año lectivo actual. Haz clic en uno para entrar a su portal.',
                    side: "top",
                    align: 'center'
                }
            },
            {
                element: '.joyride-course-card .joyride-edit-btn',
                popover: {
                    title: '<i class="fas fa-palette text-primary me-2"></i> Personalización',
                    description: 'Dale tu toque personal: cambia el color de fondo o sube una imagen de portada para identificarlo más rápido.',
                    side: "left",
                    align: 'center'
                }
            }
        ]
    });
    driverObj.drive();
};

// 2. PORTAL DOCENTE (DASHBOARD DEL CURSO)
export const startPortalDocenteTour = () => {
    const driverObj = driver({
        ...commonConfig,
        steps: [
            {
                element: '.dashboard-widget:first-child',
                popover: {
                    title: '<i class="fas fa-info-circle text-primary me-2"></i> Información del Curso',
                    description: 'Aquí ves rápidamente el nombre de la asignatura, el grado, la sección y la sede donde dictas.',
                    side: "right",
                    align: 'start'
                }
            },
            {
                element: '.modules-grid',
                popover: {
                    title: '<i class="fas fa-tools text-primary me-2"></i> Centro de Mando',
                    description: 'Estos son tus módulos de trabajo. Desde aquí gestionas todo tu curso.',
                    side: "top",
                    align: 'center'
                }
            },
            {
                element: '#module-unidades',
                popover: {
                    title: '<i class="fas fa-calendar-alt text-primary me-2"></i> Unidades y Sesiones',
                    description: '<b>¡Lo más importante!</b> Aquí defines tus unidades de aprendizaje y creas tus sesiones de clase diaria.',
                    side: "bottom",
                    align: 'center'
                }
            },
            {
                element: '#module-tareas',
                popover: {
                    title: '<i class="fas fa-tasks text-primary me-2"></i> Tareas y Actividades',
                    description: 'Crea tareas para los alumnos, sube materiales y califica sus entregas directamente.',
                    side: "bottom",
                    align: 'center'
                }
            },
            {
                element: '#module-pesos',
                popover: {
                    title: '<i class="fas fa-balance-scale text-primary me-2"></i> Configuración de Pesos',
                    description: 'Define cómo se calculará el promedio: ¿Cuánto vale el examen? ¿Cuánto las tareas? Configúralo aquí.',
                    side: "bottom",
                    align: 'center'
                }
            }
        ]
    });
    driverObj.drive();
};

// 3. CONFIGURAR EVALUACIÓN (PESOS)
export const startDocenteConfigEvalTour = () => {
    const driverObj = driver({
        ...commonConfig,
        steps: [
            {
                element: '.unit-select',
                popover: {
                    title: '<i class="fas fa-calendar-day text-primary me-2"></i> Selecciona la Unidad',
                    description: 'Los pesos se configuran por cada unidad (bimestre/trimestre). Asegúrate de elegir la correcta.',
                    side: "bottom",
                    align: 'center'
                }
            },
            {
                element: '.models-grid',
                popover: {
                    title: '<i class="fas fa-magic text-primary me-2"></i> Modelos Sugeridos',
                    description: '¿No quieres empezar de cero? Elige uno de estos modelos (como el Tradicional Orión) para configurarlo en un clic.',
                    side: "bottom",
                    align: 'center'
                }
            },
            {
                element: '.table-custom',
                popover: {
                    title: '<i class="fas fa-chart-bar text-primary me-2"></i> Tus Categorías',
                    description: 'Aquí verás el listado de lo que vas a evaluar. Puedes editarlas o borrarlas según necesites.',
                    side: "top",
                    align: 'center'
                }
            },
            {
                element: '.total-indicator-card',
                popover: {
                    title: '<i class="fas fa-check-circle text-primary me-2"></i> La Regla de Oro',
                    description: 'La suma de tus pesos <b>debe ser exactamente 100%</b>. Este indicador te avisará si te falta o te sobra.',
                    side: "right",
                    align: 'center'
                }
            }
        ]
    });
    driverObj.drive();
};

// 4. SESIONES DE CLASE (AULA VIRTUAL DOCENTE)
export const startDocenteSesionesTour = () => {
    const driverObj = driver({
        ...commonConfig,
        steps: [
            {
                element: '.joyride-course-selector',
                popover: {
                    title: '<i class="fas fa-book-open text-primary me-2"></i> Selector de Curso',
                    description: 'Desde aquí puedes cambiar rápidamente entre tus asignaturas para gestionar las sesiones de cada una.',
                    side: "bottom",
                    align: 'start'
                }
            },
            {
                element: '.joyride-view-toggles',
                popover: {
                    title: '<i class="fas fa-eye text-primary me-2"></i> Modos de Vista',
                    description: '¿Prefieres ver tus clases en <b>Tarjetas 3D</b>, <b>Línea de Tiempo</b> o en una clásica <b>Tabla</b>? Elígelo libremente.',
                    side: "bottom",
                    align: 'center'
                }
            },
            {
                element: '.joyride-new-session',
                popover: {
                    title: '<i class="fas fa-plus-circle text-primary me-2"></i> Crear Sesión',
                    description: 'Inicia el día con un clic aquí para planificar tu próxima clase. (Al darle Siguiente, abriremos el formulario por ti).',
                    side: "left",
                    align: 'center',
                    onNextClick: (element, step, { config, state }) => {
                        const btn = document.querySelector('.joyride-new-session');
                        if(btn) btn.click();
                        setTimeout(() => {
                            driverObj.moveNext();
                        }, 500); // Dar suficiente tiempo a React para renderizar el modal
                    }
                }
            },
            {
                element: '.joyride-sesion-unidad',
                popover: {
                    title: '<i class="fas fa-layer-group text-primary me-2"></i> Unidad y Fechas',
                    description: 'Al elegir la Unidad de aprendizaje, calcularemos la fecha sugerida y el número consecutivo de la sesión por ti automáticamente.',
                    side: "right",
                    align: 'start'
                }
            },
            {
                element: '.joyride-sesion-ai',
                popover: {
                    title: '<i class="fas fa-robot text-primary me-2"></i> Sugerencias con IA',
                    description: '¿Falto de ideas? Haz clic en "Sugerir Plan Completo" y rellenaremos todo tu formulario con títulos y temarios basados en tu asignatura y grado.',
                    side: "top",
                    align: 'start'
                }
            },
            {
                element: '.joyride-sesion-comps',
                popover: {
                    title: '<i class="fas fa-check-double text-primary me-2"></i> Competencias MINEDU',
                    description: 'Selecciona las competencias de tu área a las cuales quieres aportar información con la clase de hoy.',
                    side: "left",
                    align: 'center'
                }
            },
            {
                element: '.joyride-btn-guardar',
                popover: {
                    title: '<i class="fas fa-save text-primary me-2"></i> Guardar Sesión',
                    description: 'Una vez completado todo, guarda tu sesión. ¡Aparecerá como borrador para que la publiques cuando estés listo!',
                    side: "top",
                    align: 'center'
                }
            }
        ]
    });
    driverObj.drive();
};

// 5. GESTIÓN DE ACTIVIDADES
export const startDocenteActividadesTour = () => {
    const driverObj = driver({
        ...commonConfig,
        steps: [
            {
                element: '.joyride-activity-sidebar',
                popover: {
                    title: '<i class="fas fa-list-ul text-primary me-2"></i> Listado de Tareas',
                    description: 'Aquí verás todas las tareas y actividades del curso ordenadas a tu gusto. Búscalas por nombre rápidamente.',
                    side: "right",
                    align: 'start'
                }
            },
            {
                element: '.joyride-new-activity',
                popover: {
                    title: '<i class="fas fa-plus-square text-primary me-2"></i> Nueva Actividad',
                    description: 'Haz clic para diseñar tareas, foros o entregas. Conecta cada actividad a una Sesión y a una Competencia.',
                    side: "bottom",
                    align: 'start'
                }
            },
            {
                element: '.joyride-activity-tabs',
                popover: {
                    title: '<i class="fas fa-sliders-h text-primary me-2"></i> Centro de Calificación',
                    description: 'Cada vez que selecciones una Tarea, este panel te permitirá ver su <b>Resumen</b>, editar su <b>Configuración</b> o ir directo a <b>Calificar</b> las entregas.',
                    side: "top",
                    align: 'center'
                }
            }
        ]
    });
    driverObj.drive();
};

// 6. CARGA DE MATERIALES (RECURSOS)
export const startSubirMaterialTour = () => {
    const driverObj = driver({
        ...commonConfig,
        steps: [
            {
                element: '#resource-page-header',
                popover: {
                    title: '<i class="fas fa-book-reader text-primary me-2"></i> Materiales de Clase',
                    description: 'En esta sección gestionas todo el material digital (PDFs, PPTs, Videos, Enlaces) que tus alumnos verán en esta sesión.',
                    side: "bottom",
                    align: 'center'
                }
            },
            {
                element: '#resource-filter-pills',
                popover: {
                    title: '<i class="fas fa-filter text-primary me-2"></i> Filtros Rápidos',
                    description: 'Filtra tus recursos por tipo: Videos, Lecturas o actividades de Taller para encontrarlos más fácil.',
                    side: "bottom",
                    align: 'center'
                }
            },
            {
                element: '#btn-subir-material',
                popover: {
                    title: '<i class="fas fa-cloud-upload-alt text-primary me-2"></i> Subir Nuevo Material',
                    description: '¡Aquí sucede la magia! Haz clic para subir un archivo desde tu PC, pegar un link de YouTube o crear una Nota Digital.',
                    side: "left",
                    align: 'center'
                }
            },
            {
                element: '.res-card:first-child',
                popover: {
                    title: '<i class="fas fa-edit text-primary me-2"></i> Gestionar Existentes',
                    description: 'Usa los tres puntos en cada tarjeta para <b>Editar</b> o <b>Eliminar</b> recursos que ya hayas subido anteriormente.',
                    side: "top",
                    align: 'center'
                }
            }
        ]
    });
    driverObj.drive();
};

// 6. PUNTEROS DE REDIRECCIÓN (MINI TOURS CONTEXTUALES)

// Cuando el usuario está en "Mis Cursos" y necesita seleccionar uno
export const startPointerMisCursosTour = () => {
    const driverObj = driver({
        ...commonConfig,
        steps: [
            {
                element: '.joyride-course-card',
                popover: {
                    title: '<i class="fas fa-hand-pointer text-primary me-2"></i> Paso 1: Selecciona tu Curso',
                    description: 'Haz clic en la tarjeta del curso donde quieres configurar la evaluación o crear actividades.',
                    side: "top",
                    align: 'center'
                }
            }
        ]
    });
    driverObj.drive();
};

// Cuando el usuario está en el Portal del Curso y necesita ir a Pesos
export const startPointerPesosTour = () => {
    const driverObj = driver({
        ...commonConfig,
        steps: [
            {
                element: '#module-pesos',
                popover: {
                    title: '<i class="fas fa-hand-pointer text-primary me-2"></i> Paso 2: Entra a Pesos',
                    description: '¡Ya estás dentro del curso! Ahora haz <b>clic aquí</b> en "Pesos" para configurar tus criterios de evaluación y sus porcentajes.',
                    side: "top",
                    align: 'center'
                }
            }
        ]
    });
    driverObj.drive();
};

// Cuando el usuario está en el Portal del Curso y necesita ir a Tareas
export const startPointerTareasTour = () => {
    const driverObj = driver({
        ...commonConfig,
        steps: [
            {
                element: '#module-tareas',
                popover: {
                    title: '<i class="fas fa-hand-pointer text-primary me-2"></i> Paso 2: Entra a Tareas',
                    description: '¡Ya estás dentro del curso! Ahora haz <b>clic aquí</b> en "Tareas" para crear actividades, subir materiales y calificar entregas.',
                    side: "top",
                    align: 'center'
                }
            }
        ]
    });
    driverObj.drive();
};

// Cuando el usuario está en el Portal del Curso y necesita ir a Unidades/Sesiones
export const startPointerUnidadesTour = () => {
    const driverObj = driver({
        ...commonConfig,
        steps: [
            {
                element: '#module-unidades',
                popover: {
                    title: '<i class="fas fa-hand-pointer text-primary me-2"></i> Paso 2: Entra a Unidades',
                    description: '¡Ya estás dentro del curso! Ahora haz <b>clic aquí</b> en "Unidades" para ver tus sesiones y subir material didáctico.',
                    side: "top",
                    align: 'center'
                }
            }
        ]
    });
    driverObj.drive();
};
